import { emptySplitApi } from './injectApi';

const numberDiscoveryApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    getNumberDiscovery: build.query({
      query: (params) => ({
        url: '/sales-admin/sales/admin/msisdn',
        method: 'GET',
        params,
        headers: {
          Referrer: 2,
        },
      }),
      providesTags: ['NumberDiscovery'],
    }),
    putNumberDiscovery: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/msisdn/${data.id}/partners/${data.partnerId}`,
        method: 'PUT',
      }),
      invalidatesTags: ['NumberDiscovery'],
    }),
    postNumberDiscovery: build.mutation({
      query: (data) => ({
        url: `/sales-admin/sales/admin/msisdn/partners/${data.partnerId}`,
        method: 'POST',
        data: {
          identifiers: data.identifiers,
        },
      }),
      invalidatesTags: ['NumberDiscovery'],
    }),
    postNumberDiscoveryithRange: build.mutation({
      query: ({ minId, maxId, partnerId }) => ({
        url: `/sales-admin/sales/admin/msisdn/minId/${minId}/maxId/${maxId}/partners/${partnerId}`,
        method: 'POST',
      }),
      invalidatesTags: ['NumberDiscovery'],
    }),
  }),
});

export const numberDiscoveryApiHooks = {
  useGetNumberDiscovery: numberDiscoveryApi.useGetNumberDiscoveryQuery,
  usePutNumberDiscovery: numberDiscoveryApi.usePutNumberDiscoveryMutation,
  usePostNumberDiscovery: numberDiscoveryApi.usePostNumberDiscoveryMutation,
  usePostNumberDiscoveryithRange: numberDiscoveryApi.usePostNumberDiscoveryithRangeMutation,
};
